import type { LinkRequest, LinkRouter } from "@getuserfeedback/protocol/host";

type LinkOptions = {
	router?: unknown;
};

const isLinkOptions = (value: unknown): value is LinkOptions =>
	typeof value === "object" && value !== null;

const isLinkRouter = (value: unknown): value is LinkRouter =>
	typeof value === "function";

const isPromiseLike = (value: unknown): value is PromiseLike<unknown> =>
	value !== null &&
	(typeof value === "object" || typeof value === "function") &&
	"then" in value &&
	typeof value.then === "function";

export const resolveLinkRouter = (links: unknown): LinkRouter | undefined => {
	if (links === undefined) return undefined;
	if (!isLinkOptions(links)) {
		throw new TypeError("links must be an object");
	}
	const router = links.router;
	if (!isLinkRouter(router)) {
		throw new TypeError("links.router must be a function");
	}
	return router;
};

export const invokeLinkRouter = (
	router: LinkRouter,
	request: LinkRequest,
): void => {
	const result = router(request);
	if (result === undefined) return;
	if (isPromiseLike(result)) {
		void Promise.resolve(result).catch(() => {});
	}
	throw new TypeError(
		"links.router must claim navigation synchronously and return undefined",
	);
};
